"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFacilitySelector = useFacilitySelector;
var react_1 = require("react");
var facility_1 = require("../features/slices/facility");
var hooks_1 = require("../store/hooks");
var facility_storage_1 = require("../utils/facility-storage");
var use_my_facilities_1 = require("./use-my-facilities");
function useFacilitySelector() {
    var _a;
    var dispatch = (0, hooks_1.useAppDispatch)();
    var activeFacility = (0, hooks_1.useAppSelector)(function (state) { return state.facility.facility; });
    var _b = (0, use_my_facilities_1.useMyFacilities)(), facilities = _b.facilities, isLoading = _b.isLoading, hasLoaded = _b.hasLoaded;
    (0, react_1.useEffect)(function () {
        if (!hasLoaded)
            return;
        if (!facilities.length) {
            if (activeFacility) {
                dispatch((0, facility_1.clearFacility)());
                (0, facility_storage_1.clearFacilitySession)();
            }
            return;
        }
        var isStillValid = activeFacility && facilities.some(function (facility) { return facility.id === activeFacility.id; });
        if (isStillValid)
            return;
        dispatch((0, facility_1.setFacility)(facilities[0]));
        (0, facility_storage_1.saveFacilitySession)(facilities[0]);
    }, [facilities, hasLoaded, activeFacility, dispatch]);
    var selectFacility = function (facilityId) {
        var facility = facilities.find(function (candidate) { return candidate.id === facilityId; });
        if (!facility)
            return;
        dispatch((0, facility_1.setFacility)(facility));
        (0, facility_storage_1.saveFacilitySession)(facility);
    };
    return { facilities: facilities, activeFacilityId: (_a = activeFacility === null || activeFacility === void 0 ? void 0 : activeFacility.id) !== null && _a !== void 0 ? _a : "", isLoading: isLoading, selectFacility: selectFacility };
}
